
export default {
  i18nComponentKey: 'ProductReviewsMediaCollage.components.MediaTab',
  name: 'MediaTab',
  model: { event: 'change' },
  props: {
    value: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickTab(tab) {
      if (this.value === tab) return;

      this.$emit('change', tab);
    }
  }
};
